import { GridActionsCellItem, GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import React, { FC, useEffect } from "react";
import { cacheService, cockpitService, eventsNotifier, orderService, thumbnailService } from "../../Core/Api/services";
import DataTable, { CellSize } from "../Table/table";
import ListPageHeader, { ListPageHeaderGroupActions, ListPageHeaderRight } from "../Misc/ListPageHeader";
import { useMemo } from "react";
import dayjs from "dayjs";
import {
  Checkbox,
  Chip,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
  Tooltip,
} from "@mui/material";
import { DbOrderItemInfos } from "../../Core/Api/Types/db-order-item-infos";
import GlobalConst from "../../Core/Utils/Constants/globals";
import PlaceIcon from "@mui/icons-material/Place";

import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRange } from "@mui/lab";
import TableCellStringExpend from "../Table/TableCellStringExpend/table-cell-string-expend";
import TableCellOrderStatus from "../Table/TableCellOrderStatus/table-cell-order-status";
import { GetEnumValueLabelMap, UserHasAcl, GetOrderStatusLabel } from "../../Utils/helpers";
import { OrderStatus } from "../../Core/Api/Types/order-status";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import InfoIcon from "@mui/icons-material/Info";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ReplayIcon from "@mui/icons-material/Replay";
import CancelIcon from "@mui/icons-material/Cancel";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { CancelOrdersByIds } from "../../Redux/Reducers/redux-slice-object-orders";
import { MakeOperationRequest } from "../../Core/Api/Types/make-operation-request";
import { ResourceType } from "../../Core/Api/Types/cockpit-ressource-type";
import { Action } from "../../Core/Api/Types/cockpit-action";
import { AclTypes } from "../../Core/Api/Types/acl-types";
import useBasketActions from "../../Utils/Hooks/useBasketActions";
import useCustomSnackbar from "../../Utils/Hooks/useCustomSnackbar";
import { useDispatch } from "react-redux";
import ModalSetFollowers, { ModalSetFollowersElementProps } from "../Modals/ModalSetFollowers/modal-set-followers";
import { ModalContext } from "../Modals";
import { ItemProcessingMode, OrderItemTableContext } from "../Table/OrdersTable/orders-items-table";
import ModalConfirmAction, { ModalConfirmActionElementProps } from "../Modals/ModalConfirmAction/modal-confirm-action";
import ModalOrderManualChanges, {
  ModalOrderManualChangesProps,
} from "../Modals/ModalOrderManualChanges/modal-order-manual-changes";
import { OrderProductType } from "../../Core/Api/Types/order-product-type";
import ClassIcon from "@mui/icons-material/Class";
import AdamChannelsPageFilters from "./adam-channels-page-filters";
import TableCellAdamStatusHistory from "../Table/TableCellAdamStatusHistory/table-cell-adam-status-history";
import TableCellDateTime from "../Table/TableCellDateTime/table-cell-date-time";
import { EventNotifierOperation } from "../../Core/Api/notifier-client";
import { produce } from "immer";
import { GetMetadataByTagName } from "../../Core/Utils/asset-object-utils";
import TableCellAdamObjectInfos from "../Table/TableCellAdamObjectInfos/table-cell-adam-object-infos";
import { useTranslation } from "react-i18next";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import TableUuids from "../Table/table-uuids";
import { TableCellAdamVignette } from "../Table/TableCellAdamVignette/TableCellAdamVignette";

interface OrderDeliveryTableProps {
  data: DbOrderItemInfos[];
  setDateRange: React.Dispatch<React.SetStateAction<DateRange<dayjs.Dayjs>>>;
  dateRange: DateRange<dayjs.Dayjs>;
  isCockpit?: boolean;
  context?: OrderItemTableContext;
  showPanelOrder?: React.Dispatch<React.SetStateAction<number>>;
  setSelectedItems?: React.Dispatch<React.SetStateAction<DbOrderItemInfos[]>>;
  selectedItems?: DbOrderItemInfos[];
  isLoading?: boolean;
}

export const metaTagNames = [
  // Ba metas
  "rc_ba_id",
  "rc_ba_titres_emissions",
  "rc_ba_lib_projet",
  "rc_ba_libelle",
  "rc_ba_lib_commande",
  "rc_ba_lib_sous_classe",
  "rc_ba_date_diff_emission",
  "rc_prg_datesheures_diffs",
  "rc_ba_provenance",
  "rc_ba_dateheure_livraison",
  "rc_ba_duree_prevu",
  "rc_ba_duree_def",
  "rc_ba_lib_chaine",
  "rc_ba_masquer",
  "rc_ba_date_diff_ba",
  "rc_ba_dates_diff_emissions",
  // Sources metas
  "rc_prg_id",
  "rc_prg_titre",
  "source_lib_chaines",
  "rc_prg_sous_titre",
  "rc_prg_media_id",
  "rc_prg_reserver",
  "durationSMPTE",
  "adamAssetType",
  "rc_ba_droits_debut",
  "rc_ba_droits_fin",
];

const AdamOrderDeliveryTable: FC<OrderDeliveryTableProps> = (props) => {
  const { t } = useTranslation();
  const {
    data,
    setDateRange,
    dateRange,
    isCockpit = false,
    showPanelOrder,
    setSelectedItems,
    selectedItems,
    context = OrderItemTableContext.Normal,
    isLoading = false,
  } = props;

  // Custom hooks
  const apiGrid = useGridApiRef();
  const enqueueCustomSnackbar = useCustomSnackbar();
  const { modifyObjectByIdToBasket, copyObjectByIdToBasket } = useBasketActions();
  const dispatch = useDispatch();

  // Acls
  const aclApprove = UserHasAcl(AclTypes.aclOrderApprove);
  const aclCancel = UserHasAcl(AclTypes.aclOrderCancel);
  const aclStart = UserHasAcl(AclTypes.aclOrderStart);
  const aclModify = UserHasAcl(AclTypes.aclOrderUpdate);
  const aclPriority = UserHasAcl(AclTypes.aclOrderAssignPriority);
  const aclSuperUser = UserHasAcl(AclTypes.aclSuperUser);
  const aclAdmin = UserHasAcl(AclTypes.aclAdmin);
  const aclOrderManualTaskExternalChangeStatus = UserHasAcl(AclTypes.aclOrderManualTaskExternalChangeStatus);
  const aclOrderAssignFollowers = UserHasAcl(AclTypes.aclOrderAssignFollowers);
  const aclQuoteValidate = UserHasAcl(AclTypes.aclOrderQuoteValidate);
  const aclCopy = UserHasAcl(AclTypes.aclSectionOrderAccess);

  // Modals
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  // Filters
  const [dataGrid, setDataGrid] = React.useState<DbOrderItemInfos[]>([]);
  const [filterText, setFilterText] = React.useState<string>("");
  const [filterChannel, setFilterChannel] = React.useState<string[]>([]);
  const [filterProvenance, setFilterProvenance] = React.useState<string[]>([]);
  const [filterType, setFilterType] = React.useState<string[]>([]);
  const [filterHidden, setFilterHidden] = React.useState<boolean>(false);

  useEffect(() => {
    setDataGrid(data);
  }, [data]);

  // SignalR
  React.useEffect(() => {
    console.debug("Connecting websocket sessions...");

    eventsNotifier.Connect().then(function (result) {
      console.debug("Hub Events Connected successfully to WebSocket and is listening to OrderItemMessage!");

      if (eventsNotifier.connection) {
        eventsNotifier.connection.on("OrderItemMessage", (data) => {
          switch (data.op) {
            case EventNotifierOperation.Create:
              if (!data.data || !data.data.id) return;
              // add row to table
              setDataGrid(
                produce((draft) => {
                  draft.unshift(data.data);
                })
              );
              break;
            case EventNotifierOperation.Update:
              // update row in table
              setDataGrid(
                produce((draft) => {
                  const index = draft.findIndex((x) => x.id === data.data.id);
                  if (index !== -1) draft[index] = data.data;
                })
              );
              break;
            case EventNotifierOperation.Delete:
              // delete row from table
              setDataGrid(
                produce((draft) => {
                  const index = draft.findIndex((x) => x.id === data.data.id);
                  if (index !== -1) draft.splice(index, 1);
                })
              );
              break;
          }
        });

        eventsNotifier.connection.on("AssetMessage", (data) => {
          switch (data.op) {
            case EventNotifierOperation.Update:
              // update row in table
              setDataGrid(
                produce((draft) => {
                  const index = draft.findIndex((x) => x.objectId === data.data.id);
                  if (index !== -1) {
                    let update = {
                      ...draft[index],
                      objectInfos: data.data,
                    };

                    draft[index] = update;
                  }
                })
              );
              break;
          }
        });
      }
    });

    // Disconnect when unmount
    return function cleanup() {
      eventsNotifier.Disconnect().then(function () {});
    };
  }, []);

  const authKey = cacheService.GetAuthKey();

  // Cols
  const columns: GridColDef<DbOrderItemInfos>[] = [
    {
      field: "thumbnail",
      headerName: "Vignette",
      hideable: true,
      flex: CellSize.small,
      minWidth: CellSize.small,
      filterable: false,
      renderCell: (data) => (
        <TableCellAdamVignette url={thumbnailService.GetThumbRefByObjectId(data?.row?.objectId, authKey!)} />
      ),
    },
    {
      field: "id",
      headerName: "Id",
      flex: CellSize.small,
      minWidth: CellSize.small,
    },
    {
      field: "object",
      headerName: "Infos",
      flex: CellSize.xlarge,
      minWidth: CellSize.xlarge,
      renderCell: (data) => <>{data.row.objectInfos && <TableCellAdamObjectInfos asset={data.row.objectInfos} />}</>,
    },
    {
      field: "chaine",
      headerName: "Chaine",
      flex: CellSize.small,
      minWidth: CellSize.small,
      valueGetter: (data, row) => GetMetadataByTagName(row?.objectInfos, "rc_ba_lib_chaine")?.value,
    },
    {
      field: "status_history",
      headerName: "Historique des statuts",
      flex: CellSize.xlarge,
      minWidth: CellSize.xlarge,
      renderCell: (data) => (
        <>
          {data.row.objectInfos && (
            <TableCellAdamStatusHistory
              data={{
                history: data.row.objectInfos.statusHistory,
                status: data.row.objectInfos.status,
                assetId: data.row.objectInfos.id,
              }}
            />
          )}
        </>
      ),
    },
    {
      field: "status",
      headerName: "Etat",
      flex: CellSize.small,
      minWidth: CellSize.small,
      type: "singleSelect",
      valueOptions: GetEnumValueLabelMap(OrderStatus, GetOrderStatusLabel).filter(
        (x) => data.findIndex((o) => o.status === x.value) >= 0
      ),
      renderCell: (data) => <TableCellOrderStatus data={data} hideText />,
    },
    {
      field: "creationTime",
      headerName: t("common:upperCaseCreation"),
      type: "date",
      flex: CellSize.medium,
      minWidth: CellSize.medium,
      valueGetter: (data, row) => (row.creationTime === null ? null : new Date(row.creationTime)),
      renderCell: (data) => (
        <TableCellDateTime
          data={{ value: { date: data.value } }}
          format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS_FR}
        />
      ),
    },
    {
      field: "message",
      headerName: t("common:message"),
      flex: CellSize.xlarge,
      minWidth: CellSize.xlarge,
      valueFormatter: (value) => `${(value as string)?.replace(/(\r\n|\n|\r)/gm, " ").substring(0, 250)}`,
      renderCell: (data) =>
        data?.row?.status !== "MANUAL_DELIVERY_BEFORE_COMPLETED" ? (
          data?.row?.status === "FAILED" || data?.row?.status === "ABORTED" ? (
            <TableCellStringExpend data={data} />
          ) : (
            data.value
          )
        ) : (
          t("table:renderCell.manualDeliveryInProgress")
        ),
    },

    {
      field: "actions",
      headerName: "",
      type: "actions",
      align: "right",
      flex: CellSize.actionsDefault,
      minWidth: CellSize.actionsDefault,
      getActions: (params: GridRowParams) => {
        if (!params || !params.row) return [];
        if (!params.row) return [];
        let activities = params?.row?.activities ? params?.row?.activities.length : 0;

        let array: any[] = [
          <Chip
            onClick={() => handleShowPanelOrder(params.row)}
            label={activities}
            color={activities > 0 ? "info" : "default"}
            icon={<ChatOutlinedIcon />}
          />,
        ];

        let play =
          (((params?.row?.status === OrderStatus.READY || params?.row?.status === OrderStatus.SCHEDULED) && aclStart) ||
            (params?.row?.status === OrderStatus.WAITING_APPROVAL && aclApprove) ||
            (params?.row?.status === OrderStatus.CREATED &&
              (params?.row?.stack === null || params?.row?.stack?.tasks?.length === 0)) ||
            params?.row?.status === OrderStatus.QUOTE_ACCEPTED) &&
          params?.row?.doable &&
          !isCockpit;
        let cancel =
          (params.row.status === OrderStatus.READY ||
            params.row.status === OrderStatus.CREATED ||
            params.row.status === OrderStatus.QUEUED ||
            params.row.status === OrderStatus.RUNNING ||
            params.row.status === OrderStatus.ABORTED ||
            params.row.status === OrderStatus.QUOTE_PROPOSED ||
            params.row.status === OrderStatus.QUOTE_REQUESTED ||
            params.row.status === OrderStatus.QUOTE_DECLINED ||
            params.row.status === OrderStatus.FAILED) &&
          params.row.isAutomatedPipeline &&
          aclCancel;
        let retry =
          aclStart &&
          (aclAdmin || aclSuperUser) &&
          (params.row.status === OrderStatus.ABORTED || params.row.status === OrderStatus.FAILED) &&
          params.row.isAutomatedPipeline;
        let retryScratch =
          (aclAdmin || aclSuperUser) &&
          (params.row.status === OrderStatus.ABORTED ||
            params.row.status === OrderStatus.FAILED ||
            params.row.status === OrderStatus.COMPLETED) &&
          params.row.isAutomatedPipeline;
        let modify =
          aclModify &&
          (params.row.status === OrderStatus.READY ||
            params.row.status === OrderStatus.QUOTE_REQUESTED ||
            params.row.status === OrderStatus.QUOTE_PROPOSED ||
            params.row.status === OrderStatus.QUOTE_DECLINED) &&
          !isCockpit;
        let priority =
          aclPriority &&
          (params.row.status === OrderStatus.READY ||
            params.row.status === OrderStatus.QUEUED ||
            params.row.status === OrderStatus.CREATED) &&
          !isCockpit;

        let copy = aclCopy && params?.row?.status === OrderStatus.COMPLETED && !isCockpit;
        let processingMode: ItemProcessingMode = getItemProcessingMode(params.row);
        let setManualStatus =
          (processingMode === ItemProcessingMode.Manual && aclSuperUser) ||
          (processingMode === ItemProcessingMode.ManualExternal && aclOrderManualTaskExternalChangeStatus) ||
          (params?.row?.isAutomatedPipeline && params?.row?.type === OrderProductType.ManualTasks && !isCockpit);
        let setFollowers = aclOrderAssignFollowers && !isCockpit;

        if (!isCockpit)
          array.push(
            <GridActionsCellItem
              icon={<InfoIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:infos")}
              onClick={() => {
                if (showPanelOrder) showPanelOrder(params?.row?.id);
              }}
              showInMenu
            />
          );

        // Quote workflow
        if (
          aclQuoteValidate &&
          context === OrderItemTableContext.Quotes &&
          params?.row?.status === OrderStatus.QUOTE_PROPOSED
        ) {
          array.push(
            <GridActionsCellItem
              icon={
                <Tooltip title={t("tooltip:title.acceptTheOffer")}>
                  <ThumbUpIcon sx={{ width: 20, height: 20, color: "text.success" }} />
                </Tooltip>
              }
              label={t("common:accept")}
              color="success"
              onClick={() => handleAcceptOrDeclineQuote(true, params?.row?.id)}
            />
          );
          array.push(
            <GridActionsCellItem
              icon={
                <Tooltip title={t("tooltip:title.declineTheOffer")}>
                  <ThumbDownIcon sx={{ width: 20, height: 20, color: "text.warning" }} />
                </Tooltip>
              }
              label={t("common:decline")}
              color="warning"
              onClick={() => handleAcceptOrDeclineQuote(false, params?.row?.id)}
            />
          );
        }

        // Normal behaviors
        if (play)
          array.push(
            <GridActionsCellItem
              icon={<PlayCircleIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:play")}
              onClick={() => {
                orderService.PlayOrderItemById(params?.row?.id).then((response) => {
                  if (response.success) enqueueCustomSnackbar(t("alert:success.itemPlayed"), "success");
                  else
                    enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
                });
              }}
              showInMenu
            />
          );
        if (cancel)
          array.push(
            <GridActionsCellItem
              icon={<CancelIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:cancel")}
              onClick={() => {
                isCockpit
                  ? cockpitService
                      .MakeAdminOperation(
                        new MakeOperationRequest({
                          resourceId: params?.row?.id,
                          resourceType: ResourceType.OrderItem,
                          action: Action.Cancel,
                        })
                      )
                      .then((response) => {
                        if (response.success) {
                          dispatch(CancelOrdersByIds([params?.row?.id]));
                          enqueueCustomSnackbar(t("alert:success.itemCanceled"), "success");
                        } else
                          enqueueCustomSnackbar(
                            t("alert:error.oopsWithMessage", { message: response.message }),
                            "warning"
                          );
                      })
                  : orderService.CancelOrderItemById(params?.row?.id).then((response) => {
                      if (response.success) {
                        enqueueCustomSnackbar(t("alert:success.itemCanceled"), "success");
                        dispatch(CancelOrdersByIds([params?.row?.id]));
                      } else
                        enqueueCustomSnackbar(
                          t("alert:error.oopsWithMessage", { message: response.message }),
                          "warning"
                        );
                    });
              }}
              showInMenu
            />
          );
        if (retry)
          array.push(
            <GridActionsCellItem
              icon={<ReplayIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:retry")}
              onClick={() => {
                isCockpit
                  ? cockpitService
                      .MakeAdminOperation(
                        new MakeOperationRequest({
                          resourceId: params?.row?.id,
                          resourceType: ResourceType.OrderItem,
                          action: Action.Retry,
                        })
                      )
                      .then((response) => {
                        if (response) enqueueCustomSnackbar(t("alert:success.itemRetried"), "success");
                      })
                  : orderService.RetryOrderItemById(params?.row?.id).then((response) => {
                      if (response) enqueueCustomSnackbar(t("alert:success.itemRetried"), "success");
                    });
              }}
              showInMenu
            />
          );
        if (retryScratch)
          array.push(
            <GridActionsCellItem
              icon={<ReplayIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:retryFromScratch")}
              onClick={() => {
                isCockpit
                  ? cockpitService
                      .MakeAdminOperation(
                        new MakeOperationRequest({
                          resourceId: params?.row?.id,
                          resourceType: ResourceType.OrderItem,
                          action: Action.RetryFromScratch,
                        })
                      )
                      .then((response) => {
                        if (response) enqueueCustomSnackbar(t("alert:success.itemRetried"), "success");
                      })
                  : orderService.RetryFromScratchOrderItemById(params?.row?.id).then((response) => {
                      enqueueCustomSnackbar(t("alert:success.itemRetriedFromScratch"), "success");
                    });
              }}
              showInMenu
            />
          );
        if (setFollowers)
          array.push(
            <GridActionsCellItem
              icon={<GroupsOutlinedIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:setFollowers")}
              onClick={() => {
                openModal &&
                  openModal<ModalSetFollowersElementProps>(ModalSetFollowers, {
                    objectIds: [params?.row?.id],
                    objectType: "orderItem",
                    currentFollowersIds: params?.row?.followerUserIds,
                  });
              }}
              showInMenu
            />
          );
        if (
          modify &&
          (params?.row?.status === OrderStatus.READY ||
            ((aclSuperUser || aclAdmin) &&
              (params?.row?.status === OrderStatus.QUOTE_REQUESTED ||
                params?.row?.status === OrderStatus.QUOTE_PROPOSED ||
                params?.row?.status === OrderStatus.QUOTE_DECLINED)))
        )
          array.push(
            <GridActionsCellItem
              icon={<EditIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:modify")}
              onClick={() => modifyObjectByIdToBasket(params?.row?.id)}
              showInMenu
            />
          );
        if (copy)
          array.push(
            <GridActionsCellItem
              icon={<ShoppingBagOutlinedIcon />}
              label={t("table:cellLabel.makeNewOrder")}
              onClick={() => copyObjectByIdToBasket(params?.row?.id)}
              showInMenu
            />
          );
        if (setManualStatus)
          array.push(
            <GridActionsCellItem
              icon={<AutoFixHighIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:applyManualChanges")}
              onClick={() => handleManualChanges(params.row)}
              showInMenu
            />
          );
        if (priority) {
          if (params?.row?.priority !== 10)
            array.push(
              <GridActionsCellItem
                icon={<PriorityHighIcon />}
                label={t("table:cellLabel.setPriorityUrgent")}
                onClick={() => handleSetPriority(params?.row?.id, 10)}
                showInMenu
              />
            );
          if (params?.row?.priority !== 9)
            array.push(
              <GridActionsCellItem
                icon={<ArrowUpwardIcon />}
                label={t("table:cellLabel.setPriorityHigh")}
                onClick={() => handleSetPriority(params?.row?.id, 9)}
                showInMenu
              />
            );
          if (params?.row?.priority !== 5)
            array.push(
              <GridActionsCellItem
                icon={<ArrowForwardIcon />}
                label={t("table:cellLabel.setPriorityNormal")}
                onClick={() => handleSetPriority(params?.row?.id, 5)}
                showInMenu
              />
            );
          if (params?.row?.priority !== 2)
            array.push(
              <GridActionsCellItem
                icon={<ArrowDownwardIcon />}
                label={t("table:cellLabel.setPriorityLow")}
                onClick={() => handleSetPriority(params?.row?.id, 2)}
                showInMenu
              />
            );
        }

        return array;
      },
    },
  ];

  // Helpers
  const getItemProcessingMode = (item: any): ItemProcessingMode => {
    if ((item.isAutomatedPipeline && !item.manualTasksTemplateId) || item.manualTasksTemplateId === 0)
      return ItemProcessingMode.Auto;
    else {
      if (item.manualTasksTemplate && item.manualTasksTemplate.isTreatedExternally)
        return ItemProcessingMode.ManualExternal;

      return !item.isAutomatedPipeline ? ItemProcessingMode.Manual : ItemProcessingMode.Hybrid;
    }
  };

  // Actions | Handlers
  const handleShowPanelOrder = (e: any) => {
    if (showPanelOrder) showPanelOrder(e.id);
  };

  const handleSetPriority = (itemId: number, priority: number) => {
    orderService.SetPriorityOnOrderItemById(itemId, priority).then((response) => {
      enqueueCustomSnackbar(t("alert:success.itemPriorityChanged"), "success");
    });
  };

  const handleManualChanges = (item: DbOrderItemInfos) => {
    openModal &&
      openModal<ModalOrderManualChangesProps>(ModalOrderManualChanges, {
        closeModal: () => false,
        items: [item],
      });
  };

  const handleAcceptOrDeclineQuote = (accept: boolean, id: number) => {
    if (accept) {
      orderService
        .ApplyManualChangesOnItemById({
          itemId: id,
          status: OrderStatus.QUOTE_ACCEPTED,
          message: t("alert:success.userHasAcceptedQuote"),
          doable: true,
          nonDoableFlag: null,
        })
        .then((response) => {
          if (response.success)
            orderService.PlayOrderItemById(id).then((response) => {
              if (response.success) enqueueCustomSnackbar(t("alert:success.quoteAcceptedAndPlayed"), "success");
              else enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
            });
        });
    } else {
      if (!openModal) return;

      openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
        displayComment: true,
        commentLabel: t("modal:body.letUsMessageToExplainYourDecline"),
        title: t("modal:title.declineQuoteProposal"),
        onConfirm: (comment) => {
          orderService
            .ApplyManualChangesOnItemById({
              itemId: id,
              status: OrderStatus.QUOTE_DECLINED,
              message: comment ?? t("modal:message.userHasDeclinedOffer"),
              doable: true,
              nonDoableFlag: null,
            })
            .then((response) => {
              if (response.success) enqueueCustomSnackbar(t("alert:success.quoteDeclined"), "success");
              else enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
            });
        },
      });
    }
  };

  const handleFilterProvenance = (event: SelectChangeEvent<typeof filterProvenance>) => {
    const {
      target: { value },
    } = event;
    setFilterProvenance(typeof value === "string" ? value.split(",") : value);
  };

  const handleFilterType = (event: SelectChangeEvent<typeof filterType>) => {
    const {
      target: { value },
    } = event;
    setFilterType(typeof value === "string" ? value.split(",") : value);
  };

  const handleFilterHiddenChange = (event) => {
    setFilterHidden(event.target.checked);
  };

  const filteredRows = useMemo(
    () =>
      [...dataGrid]
        .filter((x) => GetMetadataByTagName(x.objectInfos, "adamAssetType")?.value !== "source")
        .filter(
          (x) =>
            filterChannel.length === 0 ||
            filterChannel.includes(GetMetadataByTagName(x.objectInfos, "rc_ba_lib_chaine")?.value) ||
            filterChannel.includes(GetMetadataByTagName(x.objectInfos, "rc_ba_lib_chaine_enfant")?.value)
        )
        .filter(
          (x) =>
            filterProvenance.length === 0 ||
            filterProvenance.includes(GetMetadataByTagName(x.objectInfos, "rc_ba_provenance")?.value)
        )
        .filter(
          (x) =>
            filterType.length === 0 ||
            filterType.includes(GetMetadataByTagName(x.objectInfos, "rc_ba_lib_projet")?.value)
        )
        .filter((x) =>
          filterHidden
            ? GetMetadataByTagName(x.objectInfos, "rc_ba_masquer")?.value
            : !GetMetadataByTagName(x.objectInfos, "rc_ba_masquer")?.value
        )
        .filter(
          (x) =>
            !filterText ||
            GetMetadataByTagName(x.objectInfos, "rc_ba_titres_emissions")?.value.includesAllWords(filterText) ||
            GetMetadataByTagName(x.objectInfos, "rc_ba_libelle")?.value.includesAllWords(filterText) ||
            GetMetadataByTagName(x.objectInfos, "rc_ba_lib_projet")?.value.includesAllWords(filterText) ||
            GetMetadataByTagName(x.objectInfos, "rc_ba_lib_commande")?.value.includesAllWords(filterText) ||
            GetMetadataByTagName(x.objectInfos, "rc_ba_id")?.value.includesAllWords(filterText) ||
            GetMetadataByTagName(x.objectInfos, "rc_ba_lib_sous_classe")?.value.includesAllWords(filterText)
        ),
    [dataGrid, filterChannel, filterProvenance, filterType, filterHidden, filterText]
  );

  const channelFiltersData = useMemo(() => {
    return dataGrid.map((x) => x.objectInfos!);
  }, [dataGrid]);

  return (
    <Stack pt={2} height="100%">
      <AdamChannelsPageFilters
        setFilterChannel={setFilterChannel}
        filterChannel={filterChannel}
        rows={channelFiltersData}
        isLoading={isLoading}
      />

      <ListPageHeader mb={2}>
        <ListPageHeaderGroupActions>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              sx={{ mt: "-24px !important" }}
              value={dateRange[0]}
              onChange={(newValue) => {
                newValue && setDateRange((x) => [newValue.startOf("day"), x[1]]);
              }}
              format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
            />
            <DesktopDatePicker
              sx={{ mt: "-24px !important" }}
              value={dateRange[1]}
              onChange={(newValue) => {
                newValue && setDateRange((x) => [x[0], newValue.endOf("day")]);
              }}
              format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
            />
          </LocalizationProvider>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={filterProvenance}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<PlaceIcon />}
            onChange={handleFilterProvenance}
            renderValue={(v) => {
              if (v.length === 0) return "Provenance";
              else return v.map((value) => value.toString()).join(", ");
            }}
            multiple
          >
            <MenuItem value={"SHERLOCK"}>Sherlock</MenuItem>
            <MenuItem value={"OSCAR"}>Oscar</MenuItem>
          </Select>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={filterType}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<ClassIcon />}
            onChange={handleFilterType}
            renderValue={(v) => {
              if (v.length === 0) return "Type";
              else
                return v
                  .map((value) => {
                    if (value === "EHA") return "EVS";
                    return value.toString();
                  })
                  .join(", ");
            }}
            multiple
          >
            <MenuItem value={"BAN"}>Bande-Annonce</MenuItem>
            <MenuItem value={"TDS"}>Tout de suite</MenuItem>
            <MenuItem value={"SOM"}>Sommaire </MenuItem>
            <MenuItem value={"HAB"}>Habillage</MenuItem>
            <MenuItem value={"CLI"}>Clip</MenuItem>
            <MenuItem value={"EHA"}>EVS </MenuItem>
            <MenuItem value={"NUM"}>Numérique </MenuItem>
          </Select>
          <FormControlLabel
            checked={filterHidden}
            onChange={handleFilterHiddenChange}
            control={<Checkbox />}
            label="Masquer"
          />
        </ListPageHeaderGroupActions>
        <ListPageHeaderRight>
          <OutlinedInput
            sx={{ mt: 1 }}
            label={t("common:search")}
            placeholder={t("common:search")}
            value={filterText}
            onChange={(value) => setFilterText(value.target.value.toLowerCase())}
            endAdornment={
              <InputAdornment position="end">
                {filterText && (
                  <IconButton aria-label="Clear field" onClick={() => setFilterText("")} size="small" sx={{ mr: 1 }}>
                    <CloseRoundedIcon />
                  </IconButton>
                )}
                <SearchIcon />
              </InputAdornment>
            }
          />
        </ListPageHeaderRight>
      </ListPageHeader>

      <DataTable
        loading={isLoading}
        tableKey={TableUuids.ADAM_ORDER_ITEMS}
        apiRef={apiGrid}
        rows={filteredRows}
        columns={columns}
        checkboxSelection={false}
        disableRowSelectionOnClick
        pagination={true}
        onRowClick={handleShowPanelOrder}
        selectedRows={selectedItems?.map((x) => x.id)}
        setSelectedRows={(e) =>
          setSelectedItems && setSelectedItems(dataGrid.filter((x) => (e as number[]).includes(x.id)))
        }
        initialState={{ pinnedColumns: { left: ["__check__"], right: ["actions"] } }}
        densityControl
      />
    </Stack>
  );
};

export default AdamOrderDeliveryTable;
